// ----------------------------------------------------------------------------
// Snippet: Reviews
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------


// -------------------------------------
// Dependencies
// -------------------------------------

// Styles
import './_shopify-reviews.scss';